export default "__VITE_ASSET__FGi3c1DR__"